import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { ControlledSubstance } from 'src/app/locums/models/controlled-substance.model';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-controlled-substances',
    templateUrl: './locums-recruiter-controlled-substances.component.html',
    styleUrls: ['./locums-recruiter-controlled-substances.component.scss']
})
export class LocumsRecruiterControlledSubstancesComponent implements OnInit {
    @Input() jobId: number;

    title: string;

    controlledSubstances: ControlledSubstance[];

    constructor(private readonly locumsJobService: LocumsJobService, private readonly store: Store) {}

    ngOnInit(): void {
        this.locumsJobService
            .getControlledSubstances(this.jobId)
            .pipe(untilDestroyed(this))
            .subscribe((certifications: ControlledSubstance[]) => {
                this.controlledSubstances = certifications?.filter((c) => c.isRequired);
            });

        this.store
            .select(jobDetailsLoaded)
            .pipe(
                filter((e) => e.success),
                untilDestroyed(this)
            )
            .subscribe((e) => {
                this.title = LocumsUtility.getControlledSubstanceTitle(e.job.stateName, e.job.professionName);
            });
    }
}
